import { useEffect, useState } from 'react';
import { IPlanCode } from '../Interfaces';
import useQueryParams from './useQueryParams';

const DEFAULT_PLAN_CODE = IPlanCode.SEASONAL;

function getValidPlanCode(planCode: string | undefined): IPlanCode {
  return planCode === IPlanCode.SEASONAL || planCode === IPlanCode.ANNUAL
    ? planCode
    : DEFAULT_PLAN_CODE;
}

const useSelectedPlan = () => {
  const queryParams = useQueryParams();
  const [selectedPlanCode, setSelectedPlanCode] = useState<IPlanCode>(() =>
    getValidPlanCode(queryParams?.planCode as IPlanCode),
  );

  useEffect(() => {
    setSelectedPlanCode(getValidPlanCode(queryParams?.planCode));
  }, [queryParams]);

  return { selectedPlanCode, setSelectedPlanCode };
};

export default useSelectedPlan;
